import { createRouter } from "@tanstack/react-router";
import type { Router } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen";

function NotFound() {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-2">
      <h1 className="text-2xl font-semibold">Page not found</h1>
      <a href="/introduction" className="underline">
        Go to the documentation
      </a>
    </div>
  );
}

// A fresh router per request: Workers handle concurrent requests in one
// isolate, so a shared router instance would leak match state across them.
export function getRouter(): Router<typeof routeTree> {
  return createRouter({
    routeTree,
    scrollRestoration: true,
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
    defaultNotFoundComponent: NotFound,
  });
}

declare module "@tanstack/react-router" {
  interface Register {
    router: Router<typeof routeTree>;
  }
}
